var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"36px"}},[_c('canvas',{ref:"canvas",staticStyle:{"width":"96px","height":"36px"},attrs:{"width":"192","height":"72"}})])}
var staticRenderFns = []

export { render, staticRenderFns }